import { Nav } from 'rsuite';

const RNavbar = ({ active, setActive, navItens, onSelect, ...props }) => {
  return (
    <Nav
      {...props}
      activeKey={active}
      onSelect={onSelect}
      style={{ marginBottom: 20, ...props?.style }}
      appearance="subtle"
    >
      {navItens
        .filter((x) => x)
        .map((item, index) => (
          <Nav.Item
            key={`nav-item-${index}`}
            eventKey={item?.key}
            style={{ fontSize: 20 }}
            onClick={() => setActive(item?.key)}
            disabled={item?.disabled}
          >
            {item?.name}
          </Nav.Item>
        ))}
    </Nav>
  );
};

export default RNavbar;
